export default __webpack_public_path__ + "static/media/exr-classes.9c35b1eb.png";